import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { categoryModel } from '@/models/privilege/privilege-category'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import { onBeforeMount, reactive, watch } from '@vue/composition-api'

export default function useMappingCategoryModal(props) {
  const {
    getCategoryList,
    fetchAssignCategory,
    fetchRemoveMappingCategory,
  } = categoryModel()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()
  const { pagination, onPageChange } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  })

  const categoryList = reactive({
    payload: [],
    isPrimary: 0,
    mappingList: [],
  })

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'alt_reference', label: 'Reference' },
    { key: 'category_image_url', label: 'Icon/Image' },
    { key: 'category_sub_image_url', label: 'Sub Icon/Image' },
    { key: 'category_name', label: 'Category Name' },
    { key: 'actions', label: '' },
  ]

  const fetchCategoryList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    getCategoryList.payload.Page = pagination.currentPage
    getCategoryList.payload.Limit = pagination.perPage
    getCategoryList.payload.Filters = filters
    getCategoryList.payload.Ordering = ordering.value
    getCategoryList.payload.Category_Level = 1
    getCategoryList.payload.Type = 2
    store
      .dispatch('api/apiRequest', getCategoryList)
      .then(response => {
        categoryList.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
        loading.tableOverlay = false
      })
  }

  const fetchPrivilegeDetail = () => {
    const mappingCate = props.privilegeObj.privilege_category_mapping || []
    categoryList.mappingList = mappingCate.map(o => o.category_id)
    categoryList.isPrimary = mappingCate.find(o => o.isprimary)?.category_id || 0
  }

  const resolvePrimaryMapping = categoryId => categoryId == categoryList.isPrimary

  const resolveCategoryMapping = categoryId => (
    categoryList.mappingList.filter(o => o == categoryId).length > 0
  )

  const onAssignCategory = (categoryId, fromPrimary = true) => {
    loading.tableOverlay = true
    fetchAssignCategory.payload.Category_Id = categoryId
    fetchAssignCategory.payload.Privilege_Id = props.privilegeObj.privilege_id
    fetchAssignCategory.payload.IsPrimary = fromPrimary
    store
      .dispatch('api/apiRequest', fetchAssignCategory)
      .then(response => {
        const { resp } = response.data
        categoryList.isPrimary = resp.find(o => o.isprimary)?.category_id || 0
        if (!resolveCategoryMapping(categoryId)) {
          categoryList.mappingList.push(categoryId)
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableOverlay = false
      })
  }

  const onMappingCategory = categoryId => {
    if (resolveCategoryMapping(categoryId)) {
      onRemoveMappingCategory(categoryId)
    } else {
      onAssignCategory(categoryId, false)
    }
  }

  const onRemoveMappingCategory = categoryId => {
    loading.tableOverlay = true
    fetchRemoveMappingCategory.payload.Category_Id = categoryId
    fetchRemoveMappingCategory.payload.Privilege_Id = props.privilegeObj.privilege_id
    store
      .dispatch('api/apiRequest', fetchRemoveMappingCategory)
      .then(response => {
        if (categoryId == categoryList.isPrimary) {
          categoryList.isPrimary = 0
        }
        const index = categoryList.mappingList.indexOf(categoryId)
        if (index > -1) {
          categoryList.mappingList.splice(index, 1)
        }
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableOverlay = false
      })
  }

  const onModalOpen = () => {
    // fetchPrivilegeDetail();
  }

  const onExpandTable = row => {
    row.toggleDetails()
  }

  onBeforeMount(() => {
    fetchCategoryList()
    fetchPrivilegeDetail()
  })

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchCategoryList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchCategoryList()
    },
    { deep: true },
  )

  return {
    fields,
    loading,
    categoryList,
    pagination,
    onPageChange,
    onModalOpen,
    onExpandTable,
    onSetValueSearch,
    resolvePrimaryMapping,
    resolveCategoryMapping,
    onAssignCategory,
    onMappingCategory,
  }
}
